module.exports = __webpack_public_path__ + "static/media/hat-cowboy.400d1afe.svg";